import AnalyzeService from '../../services/analyze';

// actions
export const FETCH_SURVEYS_BY_TEXT = 'FETCH_SURVEYS_BY_TEXT';
export const REMOVE_SURVEY = 'REMOVE_SURVEY';
export const ACTIVE_SURVEY = 'ACTIVE_SURVEY';
export const FETCH_SURVEY_BY_ID = 'FETCH_SURVEY_BY_ID';
export const GET_SURVEYS_PAGES = 'GET_SURVEYS_PAGES';
export const SHARE_SURVEY = 'SHARE_SURVEY';

/**
 *
 * @param {*} surveyId
 * @param {*} customerId
 * @param {*} dispatch
 */
export function fetchSurveysByText(customerId, queryText, page, sortIndex, dirIndex, dispatch) {
  const service = new AnalyzeService();
  const dataPromise = service.fetchSurveysByText(customerId, queryText, page, sortIndex, dirIndex);
  dispatch({ type: FETCH_SURVEYS_BY_TEXT, payload: dataPromise });
}

/**
 *
 * @param {*} customerId
 * @param {*} dispatch
 */
export function fetchAllSurveysByText(customerId, page, dispatch) {
  const service = new AnalyzeService();
  const dataPromise = service.fetchSurveysByText(customerId, null, page);
  dispatch({ type: FETCH_SURVEYS_BY_TEXT, payload: dataPromise });
}

/**
 *
 * @param {*} customerId
 * @param {*} dispatch
 */
export function fetchFilteredSurveysByText(customerId, queryText, page, dispatch) {
  const service = new AnalyzeService();
  const dataPromise = service.fetchSurveysByText(customerId, queryText, page);
  dispatch({ type: FETCH_SURVEYS_BY_TEXT, payload: dataPromise });
}

/**
 *
 * @param {*} customerId
 * @param {*} dispatch
 */
export function removeSurveysAndResearchText(customerId, surveyId, searchText, dispatch) {
  (async () => {
    const service = new AnalyzeService();
    const dataPromise = service.removeSurveys(customerId, surveyId);
    dispatch({ type: REMOVE_SURVEY, payload: dataPromise });

    await dataPromise;

    fetchFilteredSurveysByText(customerId, searchText, 0, dispatch);
  })();
}

/**
 *
 * @param {*} customerId
 * @param {*} dispatch
 */
export function activeSurvey(customerId, surveyId, surveyTitle, active, dispatch) {
  const service = new AnalyzeService();
  const dataPromise = new Promise((resolve, reject) => {
    service.activeSurvey(customerId, surveyId, surveyTitle, active).then(() => {
      service.fetchSurveysByText(customerId).then((resp) => {
        resolve(resp);
      }).catch((e) => reject(e));
    }).catch((e) => reject(e));
  });
  dispatch({ type: ACTIVE_SURVEY, payload: dataPromise });
}

/**
 *
 * @param {*} customerId
 * @param {*} dispatch
 */
export function updateSurvey(customerId, surveyId, surveyTitle, surveyInitialDate, surveyEndDate, usersToRemove, activations, dispatch) {
  const service = new AnalyzeService();
  const dataPromise = service.updateSurvey(customerId, surveyId, surveyTitle, surveyInitialDate, surveyEndDate, usersToRemove, activations);
  dispatch({ type: ACTIVE_SURVEY, payload: dataPromise });
}


/**
 *
 * @param {*} customerId
 * @param {*} dispatch
 */
export function fetchSurveyById(customerId, surveyId, dispatch) {
  const service = new AnalyzeService();
  const dataPromise = service.fetchSurveyById(customerId, surveyId);
  dispatch({ type: FETCH_SURVEY_BY_ID, payload: dataPromise });
}

/**
 * action: retrive surveys pages metrics
 * @param {*} customerId
 * @param {*} queryText
 * @param {*} dispatch
 */
export function surveysPages(customerId, queryText, dispatch) {
  const service = new AnalyzeService();
  const dataPromise = service.surveysPages(customerId, queryText);
  dispatch({ type: GET_SURVEYS_PAGES, payload: dataPromise });
}

/**
 * action: share survey with others customers
 * @param {*} customerId
 * @param {*} surveyId
 * @param {*} customers
 * @param {*} keepConfig
 */
export function shareSurvey(customerId, surveyId, customers, keepConfig, dispatch) {
  const service = new AnalyzeService();
  const dataPromise = service.shareSurvey(customerId, surveyId, { customers, keepConfig }).then(() => (
    service.fetchSurveyById(customerId, surveyId)
  ));
  dispatch({ type: SHARE_SURVEY, payload: dataPromise });
}
